import {
  PageHeader,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@chotca/ui";
import { useTabParam } from "@/lib/use-tab-param";
import { PlanPurchasesTab } from "./plan-purchases-tab";
import { SubscriptionPlansTab } from "./subscription-plans-tab";
import { GiftCodesTab } from "./gift-codes-tab";

// NOTE: the interview-credit tabs (TransactionsTab / CreditPacksTab) are hidden
// now that the credit economy is disabled in favour of subscriptions. The files
// are kept for reference/history; re-add the tabs if credits ever return.

export function FinanceClient() {
  const [tab, setTab] = useTabParam("purchases");
  return (
    <div className="space-y-6">
      <PageHeader
        title="Tài chính"
        description="Theo dõi đơn mua gói qua SePay và cấu hình giá / hạn mức các gói đăng ký."
      />

      <Tabs value={tab} onValueChange={setTab} className="space-y-6">
        <TabsList>
          <TabsTrigger value="purchases">Đơn mua gói</TabsTrigger>
          <TabsTrigger value="plans">Gói đăng ký</TabsTrigger>
          <TabsTrigger value="giftcodes">Mã quà tặng</TabsTrigger>
        </TabsList>
        <TabsContent value="purchases">
          <PlanPurchasesTab />
        </TabsContent>
        <TabsContent value="plans">
          <SubscriptionPlansTab />
        </TabsContent>
        <TabsContent value="giftcodes">
          <GiftCodesTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
